class BESSAppProjectInitiativesEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.updating = false;
        this.libraryInnovations = editor.data.origData.library_innovations;
        this.initiativeValue = {};
        this.initialising = true;
        this._forEachItem(this.#updateItemState);
        this.initialising = false;
    }


    onInputChanged(input, value) {
        super.onInputChanged(input, value);
        this.#updateItemState(this.getItemFor(input.item));
    }

    addedNewItem(item) {
        this.initialising = true;
        this.initiativeValue = {};
        this._forEachItem(this.#updateItemState);
        this.initialising = false;
    }

    #updateItemState(item) {
        if (this.updating) return;
        this.updating = true;
        let initiativeField = item.inputs.initiative;

        if (!initiativeField) {
            this.updating = false;
            return;
        }

        let initiativeValue = initiativeField.getValue();
        if (initiativeValue != null && initiativeValue.key != null) {
            initiativeValue = initiativeValue.key;
        }

        let existingInitiativeValue = this.initiativeValue[item.itemIndex];

        if (existingInitiativeValue && existingInitiativeValue === initiativeValue) {
            this.updating = false;
            return;
        }

        let nameField = item.inputs.name;
        let descriptionField = item.inputs.description;
        let pointsTargetedField = item.inputs.pointsTargeted;

        let pointsField = item.inputs.points;
        let hasSelection = initiativeValue !== undefined && initiativeValue !== '' && initiativeValue != null && initiativeValue !== -1;
        nameField.hideIf(!hasSelection);
        descriptionField.hideIf(!hasSelection);
        pointsTargetedField.hideIf(!hasSelection);
        pointsField.hideIf(!hasSelection);

        if (hasSelection) {
            this.initiativeValue[item.itemIndex] = initiativeValue;

            if (initiativeValue === "O") {
                if (!this.initialising) {
                    nameField.clear();
                    descriptionField.clear();
                    pointsTargetedField.clear();
                }
                pointsField.hideIf(true);
                pointsTargetedField.hideIf(false);
                nameField.hideIf(false);
            } else {
                this.forEach(this.libraryInnovations, function (data) {

                    if (data.id === parseInt(initiativeValue)) {
                        nameField.setValue(data.name);
                        nameField.hideIf(true);
                        descriptionField.setValue(data.description);
                        pointsField.setValue(data.points);
                        pointsTargetedField.hideIf(true);
                        pointsField.hideIf(false);
                    }

                });
            }
        }
        this.updating = false;
    }
}